import { type OptionHTMLAttributes } from 'react'

export interface NativeSelectOption {
  value: OptionHTMLAttributes<HTMLOptionElement>['value']
  label: OptionHTMLAttributes<HTMLOptionElement>['label']
}

export const isNativeSelectOptionsArray = (
  item: unknown[],
): item is NativeSelectOption[] => {
  return item.every(
    (item) =>
      typeof item === 'object' &&
      item !== null &&
      'value' in item &&
      'label' in item,
  )
}

export interface NativeSelectProps {
  ariaLabel: string
  className?: string
  defaultValue: string
  id: string
  onSelect: (value: string) => void
  options: NativeSelectOption[] | React.ReactElement[]
}
